export default __webpack_public_path__ + "static/media/avatar-mp-2-1.a15e4e63.png";